<template>
  <ContentView>
    <template slot="contentBox">
      <div class="detail-form-box">
        <el-form :model="form" size="small">
          <div class="upload-img-box">
            <div class="upload-img">
              <img :src="form.logoPath" alt />
            </div>
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :before-upload="handleChange"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div> -->
            </el-upload>
          </div>
          <div class="form-box-fr">
            <el-form-item v-if="pageType=='detail'" label="企业编号*" :label-width="formLabelWidth">
              <el-input v-model="form.orgCode" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item v-if="pageType=='add'" label="手机号" :label-width="formLabelWidth">
              <el-input v-model="form.UserName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item v-if="pageType=='add'" label="姓名" :label-width="formLabelWidth">
              <el-input v-model="form.RealName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="企业名称" :label-width="formLabelWidth">
              <el-input v-model="form.orgName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="简称" :label-width="formLabelWidth">
              <el-input v-model="form.orgName_Short" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="介绍" :label-width="formLabelWidth">
              <el-input v-model="form.orgIntroduction" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="地址" :label-width="formLabelWidth">
              <el-input v-model="form.address" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="联系人" :label-width="formLabelWidth">
              <el-input v-model="form.linkman" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="电话" :label-width="formLabelWidth">
              <el-input v-model="form.contactNumber" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="企业类型" :label-width="formLabelWidth">
              <el-select style="width:100%;" v-model="orgType" @change="typeChange" placeholder="请选择">
                <el-option
                  v-for="item in orgTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <!-- <el-input v-model="sjConfig.orgType[form.orgType]" autocomplete="off"></el-input> -->
            </el-form-item>
            <el-form-item v-if="pageType=='detail'" label="注册日期" :label-width="formLabelWidth">
              <!-- <el-input v-model="form.registrationDate" autocomplete="off"></el-input> -->
              <el-date-picker
                v-model="form.registrationDate"
                type="date"
                style="width:100%;"
                placeholder="注册日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item v-if="pageType=='detail'" label="到期日期" :label-width="formLabelWidth">
              <!-- <el-input v-model="form.expireDate" autocomplete="off"></el-input> -->
              <el-date-picker
                v-model="form.expireDate"
                type="date"
                style="width:100%;"
                placeholder="到期日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="状态" :label-width="formLabelWidth">
              <el-radio-group v-model="form.orgState">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">停用</el-radio>
                
              </el-radio-group>
            </el-form-item>
            <el-form-item label="备注" :label-width="formLabelWidth">
              <el-input v-model="form.remark" autocomplete="off"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="pagnation">
      <div>
        <el-button type="primary" @click="save()">保存</el-button>
        <el-button @click="onClose()">关闭</el-button>
        <!-- <b-button class="mr-3">Button</b-button>
              <b-button class="mr-3" >Button</b-button>
              <b-button class="mr-3" variant="success">Button</b-button>
              <b-button class="mr-3" variant="primary">Button</b-button>
        <button class="mr-3" variant="primary">确定</button><button type="reset" class="btn btn-secondary">取消</button>-->
      </div>
    </template>
  </ContentView>
</template>
<script>
import ContentView from "@/components/ContentView";
import apiPub from "@/api/public.js";
export default {
  name: "enterprise",
  data() {
    return {
      dialogFormVisible: false,
      form: {
        UserName:"",
        RealName:"",
        orgName_Short:"",
        orgName:"",
        logoPath:"",
        orgIntroduction:"",
        address:"",
        linkman:"",
        orgType:"",
        contactNumber:"",
        registrationDate:"",
        expireDate:"",
        orgState:"",
        remark:""
      },
      formLabelWidth: "80px",
      options: {
        lable: "",
        value: ""
      },
      orgType:'',
      imageUrl:"",
      pageType:'add'
    };
  },
  components: {
    ContentView
  },
  created() {
    //   = ;
    // console.log(this.$router.query);
    // console.log(this.$router.currentRoute.query);
    this.urlData = this.$router.currentRoute.query;
    if(this.urlData.id){
       this.load();
       this.pageType="detail"
    }
   
  },
  computed: {
    orgTypeList() {
      var list = [];
      for (let i in this.sjConfig.orgType) {
        // console.log(i);
        list.push({
            value:i,
            label: this.sjConfig.orgType[i],
        });
      }
    //    console.log(list)
      return list;
    },
    orgStateList() {
      var list=[];
      for (let i in this.sjConfig.orgState) {
        // console.log(i);
        list.push({
            value: i,
            label: this.sjConfig.orgState[i],
        });
      }
    //   console.log(list)
      return list;
    }
  },
  methods: {
    //---------------查询区域--------begin-----------
    load() {
      var that = this;
      var obj = {
        url: apiPub.GetEnterpriseById,
        data: {
          id: this.urlData.id
        }
      };
      $http.request(obj, false, function(res) {
        // console.log(res);
        if (res.code == 200) {
          that.form = res.data;
          console.log(that.form)
          that.orgType=that.sjConfig.orgType[res.data.orgType]
        }
      });
    },
    onClose() {
    //   this.$router.back(-1);
      this.$router.push({ name: 'enterprise'});
    },
    //---------------业务区域--------end-----------
    typeChange(e){
        // console.log(e)
        this.form.orgType=e;
    },
    init() {
    },
    handleChange(file) {
        // console.log(file)
        var that=this;
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
            return;
        }
        $http.onUpload('LOGO/'+file.name,file,function(res){
            // console.log(res)
            if(res.url){
                that.form.logoPath = res.linkurl;
            }else{
                that.form.logoPath = URL.createObjectURL(file);
            }
        })
        
    },
    save() {
      //   UpdateEnterprise;
      console.log(this.form)
      if(this.form.UserName==''){
        this.$message({
          message: "手机号不能为空",
          type: "warning",
        });
        return;
      }
      if(this.form.RealName==''){
        this.$message({
          message: "姓名不能为空",
          type: "warning",
        });
        return;
      }
      if(this.form.orgName.length<4||this.form.orgName_Short.length<4){
        this.$message({
          message: "企业名称,企业简称不能少于4个字",
          type: "warning",
        });
        return;
      }
     if(this.form.linkman==''){
        this.$message({
          message: "联系人不能为空",
          type: "warning",
        });
        return;
      }
      if(this.form.orgType==''){
        this.$message({
          message: "请选择企业类型",
          type: "warning",
        });
        return;
      }
      var that = this;
      var obj = {
        url: apiPub.RegisterOrgUser,
        data: {
          OrgName_Short: this.form.orgName_Short,
          OrgName: this.form.orgName,
          LogoPath: this.form.logoPath,
          OrgIntroduction: this.form.orgIntroduction,
          Address: this.form.address,
          Linkman: this.form.linkman,
          OrgType: this.form.orgType,
          ContactNumber: this.form.contactNumber,
          RegistrationDate: this.form.registrationDate,
          ExpireDate: this.form.expireDate,
          OrgState: this.form.orgState,
          Remark: this.form.remark
        }
      };
      if(this.form.id){
        obj.url=apiPub.UpdateEnterprise;
        obj.data.id=this.form.id;
      }else{
        obj.data.UserName=this.form.UserName;
        obj.data.RealName=this.form.RealName;
      }
      $http.request(obj, false, function(res) {
        // console.log(res);
        if (res.code == 200) {
            that.$message({
                message: '修改成功',
                type: 'success'
            });
            that.onClose()
          //   that.form = res.data;
        }
      });
    },
    //---------------表格操作--------begin-----------
   
    /// -----------------------分页--begin-----------------------------
    /// -----------------------分页--end-------------------------------
  }
};
</script>
